/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { ISecurityRequirementParent } from '../../core/models/common/ISecurityRequirementParent';
import { SecurityRequirement } from '../../core/models/common/SecurityRequirement';

/**
 * A command used to replace a definition schema with a newer version.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class ReplaceSecurityRequirementCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _oldRequirement : any;

    public _newRequirement : any;

    public _replaced : boolean;

    public constructor(old? : any, replacement? : any) {
        if(((old != null && old instanceof <any>SecurityRequirement) || old === null) && ((replacement != null && replacement instanceof <any>SecurityRequirement) || replacement === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldRequirement===undefined) this._oldRequirement = null;
            if(this._newRequirement===undefined) this._newRequirement = null;
            if(this._replaced===undefined) this._replaced = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldRequirement===undefined) this._oldRequirement = null;
            if(this._newRequirement===undefined) this._newRequirement = null;
            if(this._replaced===undefined) this._replaced = false;
            (() => {
                this._parentPath = Library.createNodePath(old.parent());
                this._oldRequirement = Library.writeNode(old);
                this._newRequirement = Library.writeNode(replacement);
            })();
        } else if(old === undefined && replacement === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldRequirement===undefined) this._oldRequirement = null;
            if(this._newRequirement===undefined) this._newRequirement = null;
            if(this._replaced===undefined) this._replaced = false;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldRequirement===undefined) this._oldRequirement = null;
            if(this._newRequirement===undefined) this._newRequirement = null;
            if(this._replaced===undefined) this._replaced = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[ReplaceSecurityRequirementCommand] Executing.");
        this._replaced = false;
        let parent : ISecurityRequirementParent = <ISecurityRequirementParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let oldRequirement : SecurityRequirement = parent.createSecurityRequirement();
        Library.readNode(this._oldRequirement, oldRequirement);
        let oldIdx : number = this.indexOfRequirement(parent.getSecurityRequirements(), oldRequirement);
        if(oldIdx === -1) {
            return;
        }
        let newRequirement : SecurityRequirement = parent.createSecurityRequirement();
        Library.readNode(this._newRequirement, newRequirement);
        /* set */(parent.getSecurityRequirements()[oldIdx] = newRequirement);
        this._replaced = true;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[ReplaceSecurityRequirementCommand] Reverting.");
        if(!this._replaced) {
            return;
        }
        let parent : ISecurityRequirementParent = <ISecurityRequirementParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let replacementRequirement : SecurityRequirement = parent.createSecurityRequirement();
        Library.readNode(this._newRequirement, replacementRequirement);
        let idx : number = this.indexOfRequirement(parent.getSecurityRequirements(), replacementRequirement);
        if(idx === -1) {
            return;
        }
        let originalRequirement : SecurityRequirement = parent.createSecurityRequirement();
        Library.readNode(this._oldRequirement, originalRequirement);
        /* set */(parent.getSecurityRequirements()[idx] = originalRequirement);
    }

    indexOfRequirement(requirements : Array<SecurityRequirement>, requirement : SecurityRequirement) : number {
        let idx : number = 0;
        for(let index210=0; index210 < requirements.length; index210++) {
            let r = requirements[index210];
            {
                if(this.isEqual(r, requirement)) {
                    return idx;
                }
                idx++;
            }
        }
        return -1;
    }

    isEqual(req1 : SecurityRequirement, req2 : SecurityRequirement) : boolean {
        let names1 : Array<string> = req1.getSecurityRequirementNames();
        let names2 : Array<string> = req2.getSecurityRequirementNames();
        if(/* size */(<number>names1.length) !== /* size */(<number>names2.length)) {
            return false;
        }
        let rval : boolean = true;
        for(let index211=0; index211 < names1.length; index211++) {
            let name1 = names1[index211];
            {
                if(names2.indexOf(name1) === -1) {
                    rval = false;
                }
            }
        }
        return rval;
    }
}
ReplaceSecurityRequirementCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ReplaceSecurityRequirementCommand";
ReplaceSecurityRequirementCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

